import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { useOpenNotificationMenuQuery } from 'modules/notifications/hooks/use-open-notification-menu-query';
import { ShareLoco } from 'modules/share/constants/share-loco';
import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum';
import { useShareResource } from 'modules/share/hooks/use-share-resource';
import { useWaitedSharingIdsStorage } from 'modules/share/hooks/use-waited-sharing-ids-storage';
import { getSuccessMessage } from 'modules/share/utils/get-success-message';
import { NextPage } from 'next';
import Router, { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Loader } from 'shared/components/loader';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const Share: NextPage = () => {
  const $ = _c(13);
  const {
    query
  } = useRouter();
  const {
    t
  } = useLocoTranslation();
  const {
    hash,
    type
  } = query as {
    hash?: string;
    type?: ShareResourceEnum;
  };
  let t0;
  if ($[0] !== hash || $[1] !== type) {
    t0 = {
      hash,
      type
    };
    $[0] = hash;
    $[1] = type;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data,
    error
  } = useShareResource(t0);
  const {
    addSharingId
  } = useWaitedSharingIdsStorage();
  let t1;
  if ($[3] !== addSharingId || $[4] !== data || $[5] !== t || $[6] !== type) {
    t1 = () => {
      if (!data) {
        return;
      }
      if ("redirect_url" in data) {
        toast.success(getSuccessMessage(t, type));
        Router.replace(data.redirect_url);
      }
      if ("sharingId" in data) {
        toast.success(getSuccessMessage(t, type));
        addSharingId(data.sharingId);
        Router.replace(`/?${useOpenNotificationMenuQuery.queryToOpenNotificationMenu}`);
      }
    };
    $[3] = addSharingId;
    $[4] = data;
    $[5] = t;
    $[6] = type;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== data || $[9] !== type) {
    t2 = [data, type];
    $[8] = data;
    $[9] = type;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let t3;
  if ($[11] !== error) {
    t3 = <div className="m-0 flex min-h-[80vh] items-center justify-center">{error ? <SectionMessage><div dangerouslySetInnerHTML={{
          __html: error.message
        }} /></SectionMessage> : <Loader />}</div>;
    $[11] = error;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export const getServerSideProps = getBaseServerSideProps(ShareLoco);
export default Share;